"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Media = _interopRequireDefault(require("./util/Media"));

var DataSync = _interopRequireWildcard(require("./util/DataSync"));

var Log = _interopRequireWildcard(require("./util/Log"));

var _cache = _interopRequireDefault(require("./util/cache"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var _flattenServers = function _flattenServers(servers) {
  var _ref;

  var _expand = servers.map(function (server) {
    var username = server.username,
        credential = server.credential,
        urls = server.urls,
        url = server.url;
    var uris = urls || url;

    if (typeof uris !== 'string') {
      return uris.map(function (uri) {
        return {
          username: username,
          credential: credential,
          urls: uri
        };
      });
    }

    return [server];
  });

  return (_ref = []).concat.apply(_ref, _toConsumableArray(_expand));
};
/**
 * The Reach configuration object
 * @class Config
 */


var Config =
/*#__PURE__*/
function () {
  /**
   * Create configuration
   * @access protected
   * @param obj
   */
  function Config(obj) {
    var _this = this;

    _classCallCheck(this, Config);

    /**
     * The default media constraints. These can be overridden when subscribing to a stream.
     * @type {MediaStreamConstraints}
     */
    this.constraints = null;
    /**
     * The id/element dom element that will hold the local video/audio element
     * @type {string|Element}
     */

    this.localStreamContainer = null;
    /**
     * The id/element dom element that will hold the remote video/audio element
     * @type {string|Element}
     */

    this.remoteStreamContainer = null;
    /**
     * The preferred video Codec. Takes a RegExp matching the codec name and sample rate.
     * Predefined values can be found in {@link Codec/video}
     * @type {RegExp}
     * @example <caption>Prefer VP9</caption>
     * var myReach = new Reach('https://io.datasync.orange.com/base/<my_namespace>', {
     *  preferredVideoCodec: Reach.codecs.video.VP9
     * });
     */

    this.preferredVideoCodec = null;
    /**
     * The preferred audio Codec. Takes a RegExp matching the codec name and sample rate.
     * Predefined values can be found in {@link Codec/audio}
     * @type {RegExp}
     * @example <caption>Prefer opus</caption>
     * var myReach = new Reach('https://io.datasync.orange.com/base/<my_namespace>', {
     *  preferredAudioCodec: Reach.codecs.audio.OPUS
     * });
     */

    this.preferredAudioCodec = null; // Populate with default values

    this.reset(); // Populate with data

    this.assign(obj); // Read ICE servers from server

    DataSync.get('_/ice').then(function (snapData) {
      if (snapData) {
        _this.iceServers = snapData.val();
        Log.i('ICEServers', _this.iceServers.length > 0 ? _this.iceServers : 'None');
      }
    }, function (e) {
      return Log.d('ICEServers', e);
    }); // TODO #Feat: Add boolean prop to request permission on start,
    // sdpEditor (for user defined SDP modifications)
  }
  /**
   * Assign new conf values
   * @access protected
   * @param {object} obj the new conf values
   */


  _createClass(Config, [{
    key: "assign",
    value: function assign(obj) {
      var _this2 = this;

      Object.keys(obj || {}).forEach(function (key) {
        _this2[key] = obj[key];
      });
    }
    /**
     * The log level (DEBUG, INFO, WARN, ERROR)
     * @type {string}
     */

  }, {
    key: "reset",

    /**
     * Resets configuration to default values
     * @protected
     */
    value: function reset() {
      this.assign({
        constraints: _Media.default.constraints(),
        logLevel: 'ERROR'
      });
    }
  }, {
    key: "logLevel",
    set: function set(level) {
      _cache.default.logLevel = level;
    }
    /**
     * The log level (DEBUG, INFO, WARN, ERROR)
     * @returns {string}
     */
    ,
    get: function get() {
      return _cache.default.logLevel;
    }
    /**
     * List of TURN/STUN servers to use for ICE.
     * This list will be merged with the ICE servers declared in the namespace (**_/ice**).
     * @type {ICEServer[]}
     */

  }, {
    key: "iceServers",
    set: function set(servers) {
      Log.d('Config~set~iceServers', servers);

      if (servers) {
        if (!this._iceServers) {
          /**
           * @ignore
           */
          this._iceServers = [].concat(servers || []);
        } else {
          // flatten existing
          var _currentServers = _flattenServers(this._iceServers); // flatten new


          var _newServers = _flattenServers(servers); // Add only the missing servers


          _newServers.forEach(function (newServer) {
            if (!_currentServers.some(function (server) {
              return server.urls === newServer.urls && server.username === newServer.username && server.credential === newServer.credential;
            })) {
              _currentServers.push(newServer);
            }
          }); // Re-group by username/credential


          this._iceServers = _currentServers.reduce(function (previous, current) {
            var username = current.username,
                credential = current.credential,
                urls = current.urls;
            var idx = previous.findIndex(function (s) {
              return s.username === username && s.credential === credential;
            });

            if (idx >= 0) {
              previous[idx].urls.push(urls);
            } else {
              previous.push({
                username: username,
                credential: credential,
                urls: [urls]
              });
            }

            return previous;
          }, []);
        }
      }
    }
    /**
     * List of TURN/STUN servers to use for ICE.
     * This list will be merged with the ICE servers declared in the namespace (**_/ice**).
     * @type {ICEServer[]}
     */
    ,
    get: function get() {
      return this._iceServers || [{
        username: 'admin',
        credential: 'webcom1234',
        urls: ['turns:turn1.webcom.orange.com:443', 'turn:turn1.webcom.orange.com:443?transport=tcp', 'turn:turn1.webcom.orange.com:3478?transport=tcp']
      }];
    }
  }, {
    key: "stats",
    set: function set(stats) {
      this._stats = Object.assign({}, stats);
    },
    get: function get() {
      return this._stats || {};
    }
  }]);

  return Config;
}();

exports.default = Config;